// extracted by mini-css-extract-plugin
module.exports = {"header":"hP","headerBg":"hQ"};